import { render, staticRenderFns } from "./ManageDocumentSeriesAllocationForm.vue?vue&type=template&id=441d30de&"
import script from "./ManageDocumentSeriesAllocationForm.vue?vue&type=script&lang=js&"
export * from "./ManageDocumentSeriesAllocationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports